import PropTypes from 'prop-types';
import React from 'react';
import * as sc from './styles';

const Pagination = ({
  currentPage,
  pdfPageCount,
  onNextClick,
  onPrevClick
}) => {
  return (
    <sc.PaginationWrapper>
      <sc.PaginationButton disabled={currentPage <= 1} onClick={onPrevClick}>
        <sc.CaretLeft />
      </sc.PaginationButton>
      <sc.PaginationBadge>
        {currentPage} / {pdfPageCount}
      </sc.PaginationBadge>
      <sc.PaginationButton
        disabled={currentPage >= pdfPageCount}
        onClick={onNextClick}
      >
        <sc.CaretRight />
      </sc.PaginationButton>
    </sc.PaginationWrapper>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  pdfPageCount: PropTypes.number,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired
};

Pagination.defaultProps = {
  pdfPageCount: 0
};

export default Pagination;
